import { render, staticRenderFns } from "./place_info.vue?vue&type=template&id=afe0dd72&scoped=true&"
import script from "./place_info.vue?vue&type=script&lang=js&"
export * from "./place_info.vue?vue&type=script&lang=js&"
import style0 from "./place_info.vue?vue&type=style&index=0&id=afe0dd72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe0dd72",
  null
  
)

export default component.exports